import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrdersInTransportInput } from './GetOrdersInTransportInput';
import { GetOrdersInTransportOutput } from './GetOrdersInTransportOutput';

export class GetOrdersInTransportService extends HttpServiceBase {

  handle = (input?: GetOrdersInTransportInput): Promise<Result<GetOrdersInTransportOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetOrdersInTransportOutput>>(`${this.baseUrlSislogApi}/v2/order/in-transport${parameters}`);
    return promise;
  }
}